import { firebaseCollections } from "globals/enums";

export const participantGroupSessionPath = (
  participantGroupId: number,
  sessionId: number,
  subPath?: string
): string => {
  const basePath = `${firebaseCollections.ParticipantGroups}/${participantGroupId}/sessions/${sessionId}`;
  return subPath ? `${basePath}/${subPath}` : basePath;
};
